<div class="flex flex-row flex-wrap">
    <fieldset class="flex flex-row flex-grow-1">
        <legend>{{ 'cloud.titles.history' | translate }}</legend>
        <div>
            <span>{{ 'stats.graphs.datepicker.from' | translate }}&nbsp;</span>
            <mat-form-field>
                <input matInput [matDatepicker]="pickerFrom" [formControl]="startDate" [max]="datenow" (dateChange)="hasChanged = true" required>
                <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error *ngIf="startDate.invalid">
                    <ng-container *ngIf="startDate.errors['required']">
                        <span>{{ 'cloud.errors.required' | translate }}</span>
                    </ng-container>
                </mat-error>
            </mat-form-field>
            <span>&nbsp;{{ 'stats.graphs.datepicker.to' | translate }}&nbsp;</span>
            <mat-form-field>
                <input matInput [matDatepicker]="pickerTo" [formControl]="endDate" [max]="datenow" (dateChange)="hasChanged = true" required>
                <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error *ngIf="endDate.invalid">
                    <ng-container *ngIf="endDate.errors['required']">
                        <span>{{ 'cloud.errors.required' | translate }}</span>
                    </ng-container>
                    <ng-container *ngIf="endDate.errors['mustBeSuperior']">
                        <span>{{ 'cloud.errors.mustBeSuperior' | translate }}</span>
                    </ng-container>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <button class="m-0" (click)="search()">{{ 'search.searchBtn' | translate }}<span *ngIf="hasChanged">*</span></button>
        </div>
        <div class="flex-grow-1"></div>
        <div>
            <mat-form-field>
                <mat-label>{{ 'cloud.menu.main.country' | translate }}</mat-label>
                <mat-select [formControl]="selectedCountry" (selectionChange)="selectedLanguage.updateValueAndValidity(); hasChanged = true" required>
                    <mat-option *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role)" [value]="0">{{ 'cloud.misc.allCountries' | translate }}</mat-option>
                    <mat-option *ngFor="let country of (possibleCountriesForLanguages[selectedLanguage.value] ?? possibleCountries) | keyvalue | orderBy: 'value | translate' " [value]="+country.key">{{ country.value | translate }}</mat-option>
                </mat-select>
                <mat-error *ngIf="selectedCountry.invalid">
                    <ng-container *ngIf="selectedCountry.errors['required']">
                        <span>{{ 'cloud.errors.required' | translate }}</span>
                    </ng-container>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field>
                <mat-label>{{ 'cloud.menu.main.language' | translate }}</mat-label>
                <mat-select [formControl]="selectedLanguage" (selectionChange)="selectedCountry.updateValueAndValidity(); hasChanged = true" required>
                    <mat-option [value]="0">{{ 'cloud.misc.allLanguages' | translate }}</mat-option>
                    <mat-option *ngFor="let language of (possibleLanguagesForCountries[selectedCountry.value] ?? possibleLanguages) | keyvalue | orderBy: 'value | translate' " [value]="language.key">{{ language.value | translate }}</mat-option>
                </mat-select>
                <mat-error *ngIf="selectedLanguage.invalid">
                    <ng-container *ngIf="selectedLanguage.errors['required']">
                        <span>{{ 'cloud.errors.required' | translate }}</span>
                    </ng-container>
                </mat-error>
            </mat-form-field>
        </div>
    </fieldset>
    <div class="loading" *ngIf="isLoading"><span>{{ 'stats.common.loading' | translate }}</span></div>
    <table class="flex-grow-1" mat-table *ngIf="logsToDisplay.length > 0" [dataSource]="logsToDisplay">
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap text-center">{{ 'history.date' | translate }}</th>
            <td mat-cell *matCellDef="let child" class="whitespace-nowrap text-center"> {{ child.date.toLocaleString(translateService.currentLang) }} </td>
        </ng-container>
        <ng-container matColumnDef="login">
            <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap text-center">{{ 'cloud.history.headers.login' | translate }}</th>
            <td mat-cell *matCellDef="let child" class="whitespace-nowrap text-center"> {{ child.login }} </td>
        </ng-container>
        <ng-container matColumnDef="langctr">
            <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap text-center">{{ 'cloud.history.headers.origin' | translate }}</th>
            <td mat-cell *matCellDef="let child" class="whitespace-nowrap text-center"> {{ getOrigin(child.details) | translate }} </td>
        </ng-container>
        <ng-container matColumnDef="directory">
            <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap text-center">{{ 'cloud.menu.create.directory' | translate }}</th>
            <td mat-cell *matCellDef="let child" class="whitespace-nowrap text-center">{{ translateFolderPath(folderPaths[child.idStockFolder], folderPaths[child.idStockFolder].split('\\') | translate) }}</td>
        </ng-container>
        <ng-container matColumnDef="file">
            <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap text-center">{{ 'cloud.menu.common.file' | translate }}</th>
            <td mat-cell *matCellDef="let child" class="text-center">{{ ((modes[child.idStockFolder] === 4) ? (commnames[child.details.split(';')[1]] ?? ('cloud.history.details.deletedComm' | translate)) : ((child.action === StockLogAction.ADD || child.action === StockLogAction.EDIT) ? filenames[child.idStockFileContent] : (filenames[child.idStockFileContent] ?? ('cloud.history.details.deletedFile' | translate)))) }}</td>
        </ng-container>
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap text-center">{{ 'cloud.history.headers.action' | translate }}</th>
            <td mat-cell *matCellDef="let child" class="text-center">
                <div class="flex flex-row align-items-center justify-content-center" [attr.title]="('cloud.history.tooltips.' + ((modes[child.idStockFolder] !== 4) ? ((child.details.split('|')[0].split(';').length > 2) ? ((child.details.split('|')[0].split(';')[4] === '0') ? 'translation' : 'country') : 'file') : 'comm') + '.' + ((child.action === StockLogAction.ADD) ? 'add' : (child.action === StockLogAction.EDIT) ? 'edit' : (child.action === StockLogAction.DELETE) ? 'delete' : '')) | translate">
                    <mat-icon [style.color]="'grey'" *ngIf="modes[child.idStockFolder] !== 4">
                        {{ (child.details.split('|')[0].split(';').length > 2) ? ((child.details.split('|')[0].split(';')[4] === '0') ? 'translate' : 'public') : 'description' }}
                    </mat-icon>
                    <i aria-hidden="true" class="fad fa-1-2x twoToneGrey" [class.fa-plus]="child.action === StockLogAction.ADD" [class.fa-edit]="child.action === StockLogAction.EDIT" [class.fa-trash-can]="child.action === StockLogAction.DELETE"></i>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap text-center">{{ 'cloud.history.headers.details' | translate }}</th>
            <td mat-cell *matCellDef="let child" class="flex flex-center">
                <ul class="m-0 pl-4">
                    <li *ngFor="let line of getDetails(child)">{{ line }}</li>
                </ul>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['date', 'login', 'langctr', 'directory', 'file', 'action', 'details']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['date', 'login', 'langctr', 'directory', 'file', 'action', 'details'];"></tr>
    </table>
</div>
